import React from 'react';
import PropTypes from 'prop-types';

import { getShipped, getPending, getDropship } from '../../utils/orders';
import DesktopProductList from './DesktopProductList';
import MobileItems from './MobileItems';

const ProductsList = ({ order, isDesktop, trackShipment }) => {
  const { shipments } = order;
  const shipped = getShipped(shipments);
  const pending = getPending(shipments);
  const dropship = getDropship(shipments);
  const handleClickTrackShipment = (trackingNumber) => trackShipment(order, trackingNumber);

  if (isDesktop) {
    return (
      <DesktopProductList
        shipped={shipped}
        pending={pending}
        dropship={dropship}
        trackShipment={handleClickTrackShipment}
      />
    );
  }
  return <MobileItems shipments={shipments} />;
};

ProductsList.propTypes = {
  order: PropTypes.shape({}).isRequired,
  isDesktop: PropTypes.bool.isRequired,
  trackShipment: PropTypes.func.isRequired,
};

export default ProductsList;
